import React from 'react';
import './Board.css';

function Board({ answers, guessedWords, lastGuessedWord, revealedLetters, justRevealedLetter }) {
  return (
    <div className="board">
      {answers.map((answer, index) => {
        const isGuessed = guessedWords.includes(answer);
        const isJustGuessed = answer === lastGuessedWord;

        let displayContent;
        if (isGuessed) {
          displayContent = answer.split('').map((char, i) => (
            <span 
              key={i} 
              className={isJustGuessed ? 'guessed-letter-animated' : ''}
              style={{ animationDelay: `${i * 0.05}s` }}
            >
              {char}
            </span>
          ));
        } else {
          displayContent = answer.split('').map((char, i) => {
            if (char === ' ' || char === '-') {
              return <span key={i} className="special-char">{char}</span>;
            }
            if (revealedLetters.has(char)) {
              // --- MUDANÇA: Verifica se a letra é a que acabou de ser revelada ---
              const isJustRevealedByHint = justRevealedLetter === char;
              return (
                <span 
                  key={i} 
                  className={`revealed-letter ${isJustRevealedByHint ? 'hint-reveal-animation' : ''}`}
                >
                  {char}
                </span>
              );
            }
            return <span key={i} className="placeholder">_</span>;
          });
        }

        return (
          <div key={index} className={`answer-slot ${isGuessed ? 'guessed' : ''}`}>
            <span className="answer-number">{index + 1}</span>
            <div className="answer-text-wrapper">{displayContent}</div>
          </div>
        );
      })}
    </div>
  );
}

export default Board;